(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('BajaDialogController', BajaDialogController);

    BajaDialogController.$inject = ['$timeout', '$uibModalInstance', 'sSAsignacion', 'sSBaja', 'TipoBaja', 'SSAsignacion', 'AlertService'];

    function BajaDialogController ($timeout, $uibModalInstance, sSAsignacion, sSBaja, TipoBaja, SSAsignacion, AlertService) {
        var vm = this;

        vm.sSBaja = sSBaja;
		
        sSAsignacion.$promise.then(function(result) {
        	vm.sSBaja.asignacion = result;
        });
        
        vm.tipoBajas = TipoBaja.all();

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.clear = clear;
        vm.save = save;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            SSAsignacion.darDeBaja(vm.sSBaja, 
				onSaveSuccess, 
				onSaveError);
        }

        function onSaveSuccess() {
            $uibModalInstance.close(true);

        }
        	
        function onSaveError () {
            vm.isSaving = false;
        	AlertService.error("Ocurrió un error al dar de baja al alumno.");
        }

        vm.datePickerOpenStatus.fechaBaja = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
